<template>
  <b-card class="border-none">
    <!-- <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class=" cursor-pointer  mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group> -->
    <el-table
      class="table-responsive table-flush  "
      header-row-class-name="thead-light table-th-color"
      :data="Data"
    >
      <el-table-column label="Sr no." prop="srno" min-width="120px" sortable>
      </el-table-column>
      <el-table-column
        label="Tax Name"
        min-width="170px"
        prop="taxname"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.taxname }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="Tax Type"
        min-width="170px"
        prop="taxtype"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black ">{{ row.taxtype }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Rate" min-width="170px" prop="rate" sortable>
        <template v-slot="{ row }">
          <span class=" text-black ">{{ row.rate }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Action" min-width="190px">
        <div class="flex items-center">
          <div class="flex items-center mr-4 cursor-pointer">
            <feather-icon
              @click="editModal = true"
              block
              icon="Edit3Icon"
              svgClasses="w-5"
            ></feather-icon>
          </div>
          <div class="flex items-center cursor-pointer">
            <feather-icon icon="Trash2Icon" svgClasses="w-5"></feather-icon>
          </div>
        </div>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="10"
        :total="50"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      Data: [
        {
          srno: "1",
          taxname: "EGname",
          taxtype: "General",

          rate: "CGST	"
        },
        {
          srno: "2",
          taxname: "EGname",
          taxtype: "General",

          rate: "CGST	"
        },
        {
          srno: "3",
          taxname: "EGname",
          taxtype: "General",

          rate: "CGST	"
        },
        {
          srno: "4",
          taxname: "EGname",
          taxtype: "General",

          rate: "CGST	"
        }
      ],
      currentPage: 1
    };
  }
};
</script>
